import { render } from "./Champ_PPS.vue?vue&type=template&id=07d0a139"
import script from "./Champ_PPS.vue?vue&type=script&lang=js"
export * from "./Champ_PPS.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Work\\Sportips\\Nouveaux modules\\nm_sportips-inscriptions\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__